
import { useState, useEffect} from "react";

import Config from "../Config";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputComboWaluty(props)
{

 
    const [gr, setGr] = useState(null);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    

    const getGr = () => {
       
 
   
       

        fetch( Config.url + '/rest_v1_home,currency', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

          
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_subkonta, res.result, props.userData);
                                
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    
         });
                   

         return false;
    }

   

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

 


        setVal(v);

        var correct = true;

        if(req == '1' &&  v=='_x_' ) correct = false;         

        if(v == '_y_del')
        {
            setView({
                v: 'new',
                id: -1
            });
            return;
        }
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'combo');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val == '_x_') correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {


   

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setClassName('');
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             setClassName('');
             props.valChange(props.name, val, correct,'');
    
        }
    })



    const onBack = (id) => {                 
        
        setVal(id);
        setGr(null);
       
  
        
        setView({
            v: 'list',
            id: -1
        });
    }




    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setGr(null);    
        }


    
    
    if( gr == null ||  gr.length == 0 )
    {
        getGr();
        
        return <fieldset>
                    <select  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cn} >
                            <option value="">...</option>
                            <option value="_y_">nowa (+)</option>
                    </select>
                    {imgx}
             <br/>
             <span className="form_err">  &nbsp; </span>   
                
           </fieldset>                     
        
    }


    

    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    var cnX = cn;
    if(val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    return <fieldset>
          
            <select   value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} >
                {
                    gr.map( (item, ix) => {
                        return <option value={item.v} key={item.v}>{item.title}</option>
                    } )
                }
              
            </select>

             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>             
         
           </fieldset>
}


export default InputComboWaluty;

